 const SESSION_TIMEOUT = 60 * 60 * 1000; // 1 hour

//const SESSION_TIMEOUT = 2 * 60 * 1000; // 2 minutes

export const startSession = () => {
  sessionStorage.setItem(
    "lastActivity",
    Date.now().toString()
  );
};

export const updateActivity = () => {
  if (sessionStorage.getItem("isLoggedIn") === "true") {
    sessionStorage.setItem(
      "lastActivity",
      Date.now().toString()
    );
  }
};

export const isSessionExpired = () => {
  const lastActivity = sessionStorage.getItem("lastActivity");

  if (!lastActivity) {
    return true;
  }

  return Date.now() - Number(lastActivity) >= SESSION_TIMEOUT;
};

export const logout = () => {
  sessionStorage.clear();
  window.location.href = "/login";
};